import {View, Text, StyleSheet} from 'react-native';
import React from 'react';
import SkillzSVG from 'SkillzSVG';
import {_m} from 'INTL';
import {EBankWithdrawalOptions, withdrawalOptionMapping} from './BankWithdrawalConstants';
import {default as SkillzStyle} from 'SkillzStyle';
import SkillzImage from 'SkillzImage';

const {fontExtraBold} = SkillzStyle.fullStyles;

type WithdrawalOptionProps = {
  selectedOption: EBankWithdrawalOptions;
};

const WithdrawalOption = ({selectedOption}: WithdrawalOptionProps) => {
  const optionDetails = withdrawalOptionMapping()[selectedOption];

  const isInstantBanking = selectedOption === EBankWithdrawalOptions.BANK_INSTANT_WITHDRAWAL;
  return (
    <View style={styles.withdrawalMethodContainer}>
      {!isInstantBanking && (
        <SkillzSVG
          style={
            isInstantBanking
              ? styles.withdrawalMethodIconInstantBanking
              : styles.withdrawalMethodIcon
          }
          source={optionDetails.icon}
        />
      )}
      {isInstantBanking && (
        <SkillzImage
          source={optionDetails.icon}
          style={styles.withdrawalMethodIconInstantBanking}
        />
      )}
      <View>
        <Text style={styles.withdrawalMethodTitle} allowFontScaling={false}>
          {optionDetails.title}
        </Text>
      </View>
    </View>
  );
};

export default WithdrawalOption;

const styles = StyleSheet.create({
  withdrawalMethodContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15,
  },
  withdrawalMethodTitle: {
    fontSize: 20,
    ...fontExtraBold,
    color: '#333',
    textAlign: 'center',
    marginTop: 8,
  },
  withdrawalMethodSubtitle: {
    fontSize: 14,
    color: '#666',
    marginTop: 4,
    textAlign: 'center',
  },
  withdrawalMethodIcon: {
    width: 30,
    height: 30,
  },

  withdrawalMethodIconInstantBanking: {
    width: 50,
    aspectRatio: 50.0 / 60.51,
  },
});
